module.exports = __webpack_public_path__ + "img/rack-icon.6283a848.svg";